import { render, staticRenderFns } from "./editTransfer.vue?vue&type=template&id=4ccd8019&scoped=true&"
import script from "./editTransfer.vue?vue&type=script&lang=js&"
export * from "./editTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccd8019",
  null
  
)

export default component.exports